module.exports = __webpack_public_path__ + "static/exmo1-f540c989bbbcc4d141cee2ec30016ab2.png";